

export class CustomizeToolTipStatusInput implements ICustomizeToolTipStatusInput {
    /** The auto-generated id of the customize tool tip master */
    customizeTooltipId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ICustomizeToolTipStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customizeTooltipId = _data["customizeTooltipId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CustomizeToolTipStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomizeToolTipStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customizeTooltipId"] = this.customizeTooltipId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICustomizeToolTipStatusInput {
    /** The auto-generated id of the customize tool tip master */
    customizeTooltipId: number;
    /** The updated status */
    status: number;
}

